import { useGLTF } from '@react-three/drei';
import { Shadow } from './_shadow';
import React, { useContext, useEffect, useRef, useState } from 'react';
import CurrentContext from '../../utils/CurrentContext';
import useSetMaterialFinish from '../../utils/useSetMaterialFinish';
import { handleExportGLTF } from '../../utils/jsHelper';
import { CushionMaterial, PaintColorMaterial } from '../../utils/materials';

export function Judy_counter_stool_painted(props) {
  const { nodes, materials, scene } = useGLTF(
    'models/Judy Counter Stool - Painted.glb',
  );

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);
  // uuid 129
  useSetMaterialFinish(
    PaintColorMaterial,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    'ao-judy_counter_stool_painted-paint_color',
    aoIntensity,
  );
  useSetMaterialFinish(
    CushionMaterial,
    currentMaterialFinish.cushionFinish,
    defaultFinish.cushionFinish,
    'ao-judy_counter_stool_painted-cushion',
    aoIntensity,
  );

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === 'Mainecottage',
      ),
    );
  }, [arRef, currentMaterialFinish]);

  useEffect(() => {
    console.log('currentScene', currentScene);
  }, [currentScene]);

  useEffect(() => {
    if (isAR && currentScene) {
      handleExportGLTF({
        currentScene,
        scene,
        fileName: 'maine_cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      {currentFinishes.cushionFinish !== 'No Cushion' ? (
        <>
          <mesh
            castShadow
            geometry={nodes.Ziper.geometry}
            material={materials.Ziper}
          />
          <mesh
            castShadow
            geometry={nodes.stiches.geometry}
            material={materials.stiches}
          />
          <mesh
            castShadow
            geometry={nodes.Cushion.geometry}
            material={CushionMaterial}
          />
        </>
      ) : null}
      <mesh
        castShadow
        geometry={nodes.Paint_Color.geometry}
        material={PaintColorMaterial}
      />
      <Shadow model={'Judy Counter Stool - Painted'} />
    </group>
  );
}
